<template>
<el-container>
  <publicHeader :currencyShow="currencyShow" @hotelLanguage="hotelLanguage" v-if="ismobile === false"></publicHeader>
  <el-main>
      <div class="main" v-show="ismobile === false" :style="{minHeight: `${mainMinHeight}px`}">
        <!--步骤条-->
        <div class="stepinfo">
          <div :class="'step-line-one-'+language">
            <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
          </div>
          <div :class="'step-line-two-'+language">
            <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
          </div>
          <div :class="'order-step-new-'+language" style="float: left;">
            <img class="step-img" src="https://res.roompai.com/static/img/order/y-one.png"> <span class="step-text">{{$t('hoteInformation')}}</span>
          </div>
          <div :class="'order-step-new-'+language">
            <img class="step-img" src="https://res.roompai.com/static/img/order/y-two.png"> <span class="step-text">{{$t('customerInformation')}}</span>
          </div>
          <div :class="'order-step-new-'+language" style="float: right;">
            <img class="step-img" src="https://res.roompai.com/static/img/order/b-three.png"> <span class="step-text">{{$t('finalStep')}}</span>
          </div>
        </div>
        <!--步骤条结束-->
        <div class="msg-main">
          <!--右侧部分-->
          <div class="msg-right-all">
            <div class="msg-right">
              <div style="margin-bottom: 10px; padding: 4.5% 4.5% 0 4.5%;">
              <div>
                <div style="font-size:18px; font-weight:650;padding-bottom: 15px;"  :class="{'blue-txt': checkData.hotelid === true}">
                  <span v-html="getLanguageHtml(hotel,'hotelname')"></span>
                </div>
                  <div style="display:inline-block;width:5%;vertical-align: top;"><i class="el-icon-location"></i></div>
                  <div style="display:inline-block;font-size:12px; color:#797979;width:90%;">
                    <span v-if="language === 'zh'"><a v-if="hotel.hoteladdress_zh !== ''">{{hotel.hoteladdress_zh}}</a><a v-else>{{hotel.hoteladdress_en}}</a></span>
                    <span v-else>{{hotel.hoteladdress_en}}</span>
                  </div>
                </div>
                <div style="font-size:16px; font-weight:650;text-align:right;">{{hotel.hotelscore}}</div>
              </div>
              <div role="progressbar" style="padding-right: 4.5%;" :aria-valuenow="hotel.hotelscore" aria-valuemin="0" aria-valuemax="5" class="el-progress el-progress--line is-exception">
                <div class="score-bar">
                  <div class="scoreNo" style="height: 6px;">
                    <div class="scoreYes" :style="hotel.hotelscoreRate">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--预定信息-->
            <div class="msg-right">
              <div class="advanceText">{{$t('bookingInformation')}}</div>
              <div class="advanceInfo">
                <div class="margin-top el-descriptions">
                  <div class="el-descriptions__body">
                    <table class="el-descriptions__table">
                      <tbody>
                        <tr>
                          <td colspan="1">
                            <div class="titletd">{{$t('roomName')}}</div>
                            <div class="infotd" :class="{'blue-txt': checkData.roomName === true}">
                              <span v-html="getLanguageHtml(orderData.roomName,'roomName')"></span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="1">
                            <div class="titletd">{{$t('checkInTime')}}</div>
                            <div class="infotd" :class="{'blue-txt': checkData.checkin === true}">
                              <span v-html="getLanguageHtml(orderData.checkin,'checkin')"></span>
                            </div>
                          </td>
                        </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('checkOutTime')}}</div>
                            <div class="infotd" :class="{'blue-txt': checkData.checkout === true}">
                              <span v-html="getLanguageHtml(orderData.checkout,'checkout')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('travelDates')}}<span v-if="orderData.night.zh !== 1">s</span></div>
                            <div class="infotd" :class="{'blue-txt': checkData.night === true}">
                              <span v-html="getLanguageHtml(orderData.night,'night')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                          <div class="titletd">{{$t('roomNumber')}}<span v-if="language === 'en' && orderData.roomNum.zh !== '1'">s</span></div>
                            <div class="infotd">
                              <span v-html="getLanguageHtml(orderData.roomNum,'roomNum')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('guest')}}</div>
                            <div class="infotd">
                              <span style="display: block;" :class="{'blue-txt': checkData.person === true}" v-html="getLanguageHtml(orderData.person,'person')"></span>
                              <span style="display: block;" v-html="getLanguageHtml(orderData.child,'child')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('bedType')}}</div>
                            <div class="infotd" :class="{'blue-txt': checkData.bedType === true}">
                              <span v-html="getLanguageHtml(orderData.bedType,'bedType')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('breakfast')}}</div>
                            <div class="infotd" :class="{'greenText': orderData.breakfastCode === true, 'blue-txt': checkData.breakfast === true}">
                              <span v-html="getLanguageHtml(orderData.breakfast,'breakfast')"></span>
                              <span v-html="getLanguageHtml(orderData.breakfast_num,'breakfast_num')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('cancellationPolicy')}}</div>
                            <div class="infotd greenText" :class="{'redText': cancelData === 0, 'blue-txt': checkData.cancel === true}">
                              <span v-if="language === 'zh'">{{orderData.cancel.zh}}</span>
                              <span v-else>{{orderData.cancel.en}}
                                <span v-if="orderData.cancel.endate !== ''"><br>{{orderData.cancel.endate}}</span>
                              </span>
                            </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!--价格详情-->
            <div class="msg-right">
              <div class="priceText">{{$t('priceDetails')}}</div>
              <div class="priceInfo">
                <div style="padding:3%;">
                  <div class="jianye" style="height:50px;">
                    <div style="float:left;" v-if="language === 'en'">
                      <span>{{orderData.roomCount}} {{$t('onOurSite')}}<span v-if="orderData.roomCount !=='1'">s</span> x {{orderData.nightCount}} {{$t('night')}}<span v-if="orderData.nightCount !== 1">s</span></span><span class="avgprice">{{$t('avgNight')}} {{orderData.fare}}</span><span class="avgprice" v-if="orderData.discount !== ''">{{$t('couponUseshortMsg')}} {{orderData.curMark}} {{orderData.discount}}</span>
                    </div>
                    <div style="float:left;" v-else>
                      <span>{{orderData.roomCount}}{{$t('onOurSite')}} x {{orderData.nightCount}}{{$t('night')}}</span><span class="avgprice">{{$t('avgNight')}} {{orderData.fare}}</span><span class="avgprice" style="color: #2f7000" v-if="orderData.discount != ''">{{$t('couponUseshortMsg')}} {{orderData.curMark}} {{orderData.discount}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.fareTotal}}</span>
                    </div>
                  </div>
                  <div class="mandatory" v-if="orderData.additionalChargeprice !== 0">
                    <div style="float:left;">{{$t('additionalCharge')}}</div>
                    <div style="float:right;">{{orderData.additionalCharge}}</div>
                  </div>
                  <div style="clear:both; height:20px;">
                    <div style="float:left; height: 25px;line-height: 25px;">
                      <span>{{$t('taxesFees')}}</span>
                      <el-popover popper-class="popverText" placement="top-start" width="327" offset="99" trigger="click" v-if="language === 'en'">
                        <div style="font-size:8px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                          {{$t('taxesAndServiceFees')}}
                        </div>
                        <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" slot="reference">
                      </el-popover>
                      <el-popover popper-class="popverText" placement="top-start" width="327" offset="44" trigger="click" v-else>
                        <div style="font-size:8px;">
                          {{$t('taxesAndServiceFees')}}
                        </div>
                        <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" slot="reference">
                      </el-popover>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.tax}}</span>
                    </div>
                  </div>
                  <!-- payableAtProperty -->
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.mandatoryFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('mandatoryFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.mandatoryFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.mandatoryTax !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('mandatoryTax')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.mandatoryTax}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.resortFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('resortFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.resortFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.cityFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('cityTaxFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.cityFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.destinationFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('destinationFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.destinationFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.serviceFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('serviceFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.serviceFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.CleaningFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('cleaningFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.CleaningFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.administrativeFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('administrativeFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.administrativeFee}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="clear:both; font-size:16px; font-weight:650; height: 54px; padding: 0px 4.5%; line-height: 54px;">
                <div style="display:inline-block;float:left;">{{$t('totalPrice')}}</div>
                <div style="display:inline-block;float:right;">{{orderData.curMark}} {{orderData.totalPrice}}</div>
              </div>
              <div style="clear: both;font-size: 14px;font-weight: 340;height: 15px;padding: 0px 4.5%;line-height: 25px;padding-bottom: 20px;" v-if="orderData.payAtProperty !== '' && patAtHotel === true">
                <div style="display:inline-block;float:left;">{{$t('payNow')}}</div>
                <div style="display:inline-block;float:right;">{{orderData.curMark}} {{orderData.payPrice}}</div>
              </div>
              <div style="clear: both;font-size: 14px;font-weight: 340;height: 15px;padding: 0px 4.5%;line-height: 15px;padding-bottom: 20px;" v-if="orderData.payAtProperty !== '' && payAtHotel === true">
                <div style="display:inline-block;float:left;">{{$t('payableAtProperty')}}</div>
                <div style="display:inline-block;float:right;">{{orderData.payAtProperty}}</div>
              </div>
              <div v-if="orderData.discount != ''">
                <div class="coupon-info">
                  <img src="/static/img/order/u207.png" class="coupon-img">
                  <span style="margin-left: 5px">{{$t('couponUselargeMsg')}} {{orderData.curMark}} {{orderData.discount}}{{$t('point')}}</span>
                </div>
                <div style="margin: 8px 0px 10px 0px;font-size:12px;">
                  <span class="coupon-text">{{$t('couponUseshortMsg')}} {{orderData.discountCode}}</span>
                </div>
              </div>
              <div style="clear: both;font-size: 12px;font-weight: 340;padding: 0px 4.5%;height: 10px;" v-if="orderData.payAtProperty !== ''">
                <div style="display:inline-block;float:left;padding-bottom: 15px;">{{$t('priceDetailMsg')}}</div>
              </div>
            </div>
          </div>
          <!--左侧部分-->
          <div class="msg-left">
            <!--登录/注册入口-->
            <div class="msg-pink">
              <div class="pink-tag">
                <div class='pink-back'>
                  <img class="pink-logo" src="/static/img/order/pay-hour.png">
                </div>
              </div>
              <div class="pink-text">
                <span>{{$t('please')}}</span>
                <span class="pink-maintext">
                  {{hourString + ':'+ minuteString + ':'+ secondString}}
                </span>
                <span>{{$t('orderPaymentRight')}}</span>
              </div>
            </div>
            <!--倒计时-->
            <div class="msg-green">
              <div class="green-tag">
                <div class='green-back'>
                  <img class="green-logo" src="/static/img/order/FFFFFF-2.png">
                </div>
              </div>
              <div class="green-text">
                <span>{{$t('encryptedSecure')}}</span>
              </div>
            </div>
            <!--卡信息-->
            <form class="el-form demo-ruleForm">
              <div class="msg-guest">
                <div style="padding: 2px 20px;">
                  <el-tabs v-model="activeName">
                  <!-- 电子支付 -->
                  <el-tab-pane :label="$t('electronicPayment')" name="electronicPayment">
                    <div>
                      <img v-for="item in paymentList" :key="item.value" :src="item.src" style="width:38px; height:25px; margin-right: 5px;">
                    </div>
                    <div>
                      <div class="long-margin" style="margin-bottom: 20px;">
                        <div>
                          <div for="name" class="msg-name">{{$t('payMethod')}}: </div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <el-select v-model="paymentOn" placeholder="请选择" @change="changePayment(paymentOn)" ref="paymentSelect" style="width:70%">
                                <el-option
                                  v-for="item in paymentList"
                                  :key="item.value"
                                  :label="getLanguageHtml(item.value,'paymentLabel')"
                                  :value="item.value">
                                  <span style="float: left"><img :src="item.src" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                  <span style="float: left;" v-html="getLanguageHtml(item.value,'paymentLabel')"></span>
                                </el-option>
                              </el-select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="long-margin">
                        <div>
                          <div for="name" class="msg-name"></div>
                          <div class="el-form-item__content">
                            <li style="line-height: 25px;" v-if="['paypal', 'alipay'].includes(paymentOn)">{{$t('youSelectPay')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabel')" style="font-weight: 400;color: #5392F9;"></span>{{$t('youWillBeForwardedTo')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabel')" style="font-weight: 400;color: #5392F9;"></span>{{$t('websiteToProceedWithThisTransaction')}}</li>
                            <li style="line-height: 25px;">{{$t('theTotalAmountYouChanged')}} <span style="font-weight: 400;color: #5392F9;">{{orderData.diffPrice}}</span></li>
                          </div>
                        </div>
                      </div>
                      <div class="long-margin">
                        <!-- <paypalButton></paypalButton> -->
                      </div>
                    </div>
                  </el-tab-pane>
                  <!-- 已存信用卡 -->
                  <el-tab-pane :label="$t('mySavedCards')" name="saveCard" v-if="payment_card_show && payment.total.status === '1'">
                    <div>
                      <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;" v-if="payment.total.typeLs.includes('visa')">
                      <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;" v-if="payment.total.typeLs.includes('master')">
                    </div>
                    <div>
                      <div class="long-margin">
                        <div class="msginfo-left">
                          <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <el-select v-model="paymentCardno" placeholder="请选择" @change="changePaymentCardno(paymentCardno)" ref="paymentCardno" style="width:100%">
                                <el-option
                                  v-for="item in payment.list"
                                  :key="item.sign"
                                  :label="item.cardno"
                                  :value="item.sign">
                                  <span style="float: left" v-if="item.type === 'visa'"><img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                  <span style="float: left" v-if="item.type === 'master'"><img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                  <span style="float: left;" v-html="item.cardno"></span>
                                </el-option>
                              </el-select>
                            </div>
                          </div>
                        </div>
                        <div class="msginfo-right">
                          <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input is-disabled">
                              <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoName">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="padding-bottom:80px;">
                        <div class="msg-half-one">
                          <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input is-disabled">
                              <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoEffectivedate">
                            </div>
                          </div>
                        </div>
                        <div class="msg-half">
                          <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShow}" ref="securityCode" @blur="blursCode('securityCode')" @click="showCardRemindInfo">
                            </div>
                            <div class="el-form-item__error" v-show="securityCodeShow">{{$t('validCVV')}}</div>
                          </div>
                        </div>
                        <div class="cardremind" v-show="showCardRemind">
                          <div class="remindimg">
                            <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                          </div>
                          <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <!-- 信用卡/借记卡 -->
                  <el-tab-pane :label="$t('creditDebitCard')" name="newCard" v-if="payment_card_show">
                    <div>
                      <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;display:inline-block;">
                      <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;">
                    </div>
                    <div>
                      <div class="long-margin">
                        <div class="msginfo-left">
                          <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username')}" ref="username" @blur="blurs('username')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('username')">
                              <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msginfo-right">
                          <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" v-model="cardNo" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardno')}" ref="cardno" @input="formatCardNumber" @blur="blurs('cardno')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('cardno')">
                              <span v-html="getLanguageHtml(cardNoError,'cardNoError')"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="padding-bottom:40px;">
                        <div class="msg-half-one">
                          <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" placeholder="MM/YY" :class="{'codeError':getSomeThing('effectivedate')}" ref="effectivedate" @blur="blurs('effectivedate')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('effectivedate')">
                              <span v-html="getLanguageHtml(effectiveDateError,'effectiveDateError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-half">
                          <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShowTwo}" ref="securityCodeTwo" @blur="blurs('securityCodeTwo')" @click="showCardRemindInfoTwo">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('securityCodeTwo')">
                              <span v-html="getLanguageHtml(securityCodeError,'securityCodeError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="cardremind" v-show="showCardRemindTwo">
                          <div class="remindimg">
                            <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                          </div>
                          <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                        </div>
                      </div>
                      <div style="height:30px;">
                        <el-checkbox v-model="checked">{{$t('rememberCard')}}</el-checkbox>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
                </div>
              </div>
              <!--完成预定-->
              <div class="msg-guest">
                <div class="tonext">
                  <p style="font-size:14px;">
                    <span v-html="$t('buttonMeansYouAgree')"></span>
                    <router-link class="remind-text" :to="{name:'clause', params: {'querys': common.linkEncode({'source': source}, 'obj')}}">{{$t('termsUse')}}</router-link> {{$t('and')}}
                    <router-link class="remind-text" :to="{name:'policy', params: {'querys': common.linkEncode({'source': source}, 'obj')}}">{{$t('privacyPolicyO')}}</router-link>
                  </p>
                  <p style="font-size:12px; font-weight:500; color: #2F7000;" v-if="cancelData !== 0">
                    <img src="https://res.roompai.com/static/img/order/2F7000.png" style="width:16px; height:16px;vertical-align: middle;">
                    {{$t('riskFree')}} <span v-html="getLanguageHtml(orderData.cancelData,'cancelData')"></span> {{$t('noCancelFeeBefore')}}
                  </p>
                  <p class="surplus-room" v-if="orderData.remainrooms === '1'">{{$t('onlyLast')}} 1 {{$t('onOurSite')}}</p>
                  <el-button class="order_button" @click="JumpOver">{{$t('bookNow')}}</el-button>
                  <!-- wechat 弹出 30%-->
                  <el-dialog :visible.sync="wechatEject"  width="450px" :show-close="wechatShowClose" class="tax-margin" top="10vh">
                    <div slot="title" style="text-align: left; font-size: 15px; color: #303133; font-weight:bold; border-bottom: 1px solid rgb(221, 223, 226); padding-bottom: 15px;">{{$t('completeWeatchPay')}}</div>
                    <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                      <div style="width: 100%;min-height: 30px;background: #F8F8FA;margin-bottom: 10px;color: #979797;">
                        <div style="width: 100%;height:30px;">
                          <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('roomName')}}</div>
                          <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                            <span v-html="getLanguageHtml(orderData.roomName,'roomName')"></span>
                          </div>
                        </div>
                        <div style="width: 100%;height:30px;">
                          <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('checkInTime')}}</div>
                          <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                            <span v-html="getLanguageHtml(orderData.checkin,'checkin')"></span>
                          </div>
                        </div>
                        <div style="width: 100%;height:30px;">
                          <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('checkOutTime')}}</div>
                          <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                            <span v-html="getLanguageHtml(orderData.checkout,'checkout')"></span>
                          </div>
                        </div>
                        <div style="width: 100%;height:30px;">
                          <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('guest')}}</div>
                          <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                            <span v-html="getLanguageHtml(orderData.person,'person')"></span>
                          </div>
                        </div>
                        <div style="width: 100%;height:30px;">
                          <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('totalPrice')}}</div>
                          <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                            <span>{{orderData.diffPrice}}</span>
                          </div>
                        </div>
                      </div>
                      <div style="width: 100%;min-height: 210px;background: #F8F8FA;margin-bottom: 10px;color: #979797;">
                        <div style="width: 100%;height:30px;">
                          <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('step1')}}</div>
                          <div style="display: inline-block;width: 75%;text-align: left;float: right;">{{$t('useWechatToQecodePay')}}</div>
                        </div>
                        <div style="width: 100%;height:30px;text-align: center;">
                          <img :src="weChatImgUrl" alt="" style="width: 150px;">
                        </div>
                      </div>
                      <div style="width: 100%;min-height: 130px;background: #F8F8FA;margin-bottom: 10px;color: #979797;">
                        <div style="width: 100%;height:85px;">
                          <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('step2')}}</div>
                          <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                            <span v-html="$t('accordingToPaymentResultSelect')"></span>
                          </div>
                        </div>
                        <div style="height: 50px;width: 100%;text-align: center;">
                          <el-button type="info" plain style="height: 35px;font-size: 12px;margin-right: 35px;" @click="wechatJumpOver"> {{$t('paymentHadProblems')}} </el-button>
                          <el-button type="primary" plain style="height: 35px;font-size: 12px;" @click="wechatJumpOver"> {{$t('paymentSpuccessful')}} </el-button>
                        </div>
                      </div>
                    </div>
                    <!-- <div @click="wechatEject = true" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">{{$t('close')}}</div> -->
                  </el-dialog>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="main"  v-show="ismobile === true">
        <!--步骤条-->
        <div class="stepinfo" :style="{ width: `${elementWidth}px` }">
          <div :style="{ width: `${stepWidth}px`}" style="margin: auto;">
            <div  :style="{ width: `${lineWidth}px`, left: `${lineOneLeft}px` }" style="position:relative; top: 12.5px;">
              <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
            </div>
            <div  :style="{ width: `${lineWidth}px`, left: `${lineTwoLeft}px` }" style="position:relative; top:12.5px;">
              <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
            </div>
            <div :class="'order-step-new-'+language" style="float: left;">
              <div><img class="step-img" src="https://res.roompai.com/static/img/order/y-one.png"></div>
              <div><span class="step-text">{{$t('hoteInformation')}}</span></div>
            </div>
            <div :class="'order-step-new-'+language">
              <div><img class="step-img" src="https://res.roompai.com/static/img/order/y-two.png"></div>
              <div><span class="step-text">{{$t('customerInformation')}}</span></div>
            </div>
            <div :class="'order-step-new-'+language" style="float: right;">
              <div><img class="step-img" src="https://res.roompai.com/static/img/order/b-three.png"></div>
              <div><span class="step-text">{{$t('finalStep')}}</span></div>
            </div>
          </div>
        </div>
        <!--步骤条结束-->
        <div style="clear: both;"></div>
        <div class="mobile-msg-main">
          <div style="font-size:12px;">
            <!--登录/注册入口-->
            <div class="msg-pink">
              <div class="pink-tag">
                <div class='pink-back'>
                  <img class="pink-logo" src="/static/img/order/pay-hour.png">
                </div>
              </div>
              <div class="pink-text">
                <div>{{$t('please')}}</div>
                <div class="pink-maintext" style="width:60px; text-align:center">{{hourString + ':'+ minuteString + ':'+ secondString}}</div>
                <span>{{$t('orderPaymentRight')}}</span>
              </div>
            </div>
            <!--倒计时-->
            <div class="msg-green">
              <div class="green-tag">
                <div class='green-back'>
                  <img class="green-logo" src="/static/img/order/FFFFFF-2.png">
                </div>
              </div>
              <div :class="'green-text-'+language">
                <span>{{$t('encryptedSecure')}}</span>
              </div>
            </div>
          </div>
          <!--右侧部分-->
          <div class="msg-right-all">
            <div class="msg-right" style="margin-top: 10px;">
              <div style="margin-bottom: 10px; padding: 4.5% 4.5% 0 4.5%;">
              <div>
                <div style="font-size:16px; font-weight:650;padding-bottom: 15px;" :class="{'blue-txt': checkData.hotelid === true}">
                  <span v-html="getLanguageHtml(hotel,'hotelname')"></span>
                </div>
                  <div style="display:inline-block;width:5%;vertical-align: top;"><i class="el-icon-location"></i></div>
                  <div style="display:inline-block;font-size:12px; color:#797979;width:90%;">
                    <span v-if="language === 'zh'"><a v-if="hotel.hoteladdress_zh !== ''">{{hotel.hoteladdress_zh}}</a><a v-else>{{hotel.hoteladdress_en}}</a></span>
                    <span v-else>{{hotel.hoteladdress_en}}</span>
                  </div>
                </div>
                <div style="font-size:16px; font-weight:650;text-align:right;">{{hotel.hotelscore}}</div>
              </div>
              <div role="progressbar" style="padding-right: 4.5%;" :aria-valuenow="hotel.hotelscore" aria-valuemin="0" aria-valuemax="5" class="el-progress el-progress--line is-exception">
                <div class="score-bar">
                  <div class="scoreNo" style="height: 6px;">
                    <div class="scoreYes" :style="hotel.hotelscoreRate">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--预定信息-->
            <div class="msg-right">
              <div class="advanceText">{{$t('bookingInformation')}}</div>
              <div class="advanceInfo">
                <div class="margin-top el-descriptions">
                  <div class="el-descriptions__body">
                    <table class="el-descriptions__table">
                      <tbody>
                        <tr>
                          <td colspan="1">
                            <div class="titletd">{{$t('roomName')}}</div>
                            <div class="infotd" :class="{'blue-txt': checkData.roomName === true}">
                              <span v-html="getLanguageHtml(orderData.roomName,'roomName')"></span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="1">
                            <div class="titletd">{{$t('checkInTime')}}</div>
                            <div class="infotd" :class="{'blue-txt': checkData.checkin === true}">
                              <span v-html="getLanguageHtml(orderData.checkin,'checkin')"></span>
                            </div>
                          </td>
                        </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('checkOutTime')}}</div>
                            <div class="infotd" :class="{'blue-txt': checkData.checkout === true}">
                              <span v-html="getLanguageHtml(orderData.checkout,'checkout')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('travelDates')}}<span v-if="orderData.night.zh !== 1">s</span></div>
                            <div class="infotd" :class="{'blue-txt': checkData.night === true}">
                              <span v-html="getLanguageHtml(orderData.night,'night')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                          <div class="titletd">{{$t('roomNumber')}}<span v-if="orderData.roomNum.zh !== '1'">s</span></div>
                            <div class="infotd">
                              <span v-html="getLanguageHtml(orderData.roomNum,'roomNum')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('guest')}}</div>
                            <div class="infotd" :class="{'blue-txt': checkData.person === true}">
                              <span v-html="getLanguageHtml(orderData.person,'person')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('bedType')}}</div>
                            <div class="infotd" :class="{'blue-txt': checkData.bedType === true}">
                              <span v-html="getLanguageHtml(orderData.bedType,'bedType')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('breakfast')}}</div>
                            <div class="infotd" :class="{'greenText': orderData.breakfastCode === true, 'blue-txt': checkData.breakfast === true}">
                              <span v-html="getLanguageHtml(orderData.breakfast,'breakfast')"></span>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="1">
                            <div class="titletd">{{$t('cancellationPolicy')}}</div>
                            <div class="infotd greenText" :class="{'redText': cancelData === 0, 'blue-txt': checkData.cancel === true}">
                              <span v-if="language === 'zh'">{{orderData.cancel.zh}}</span>
                              <span v-else>{{orderData.cancel.en}}
                                <span v-if="orderData.cancel.endate !== ''"><br>{{orderData.cancel.endate}}</span>
                              </span>
                            </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!--价格详情-->
            <div class="msg-right">
              <div class="priceText">{{$t('priceDetails')}}</div>
              <div class="priceInfo">
                <div style="padding: 4.5% 4.5% 0;">
                  <div class="jianye" style="height:50px;">
                    <div style="float:left;" v-if="language === 'en'">
                      <span>{{orderData.roomCount}} {{$t('onOurSite')}}<span v-if="orderData.roomCount !=='1'">s</span> x {{orderData.nightCount}} {{$t('night')}}<span v-if="orderData.nightCount !== 1">s</span></span><span class="avgprice">{{$t('avgNight')}} {{orderData.fare}}</span><span class="avgprice" v-if="orderData.discount !== ''">{{$t('couponUseshortMsg')}} {{orderData.curMark}} {{orderData.discount}}</span>
                    </div>
                    <div style="float:left;" v-else>
                      <span>{{orderData.roomCount}}{{$t('onOurSite')}} x {{orderData.nightCount}}{{$t('night')}}</span><span class="avgprice">{{$t('avgNight')}} {{orderData.fare}}</span><span class="avgprice" style="color: #2f7000" v-if="orderData.discount != ''">{{$t('couponUseshortMsg')}} {{orderData.curMark}} {{orderData.discount}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.fareTotal}}</span>
                    </div>
                  </div>
                  <div class="mandatory" v-if="orderData.additionalChargeprice !== 0">
                    <div style="float:left;">{{$t('additionalCharge')}}</div>
                    <div style="float:right;">{{orderData.additionalCharge}}</div>
                  </div>
                  <div style="clear:both;height:35px;">
                    <div style="float:left; height: 19px;line-height: 19px; vertical-align: middle;">
                      <span>{{$t('taxesFees')}}</span>
                      <span><img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" @click="taxDia = true"></span>
                      <el-dialog :visible.sync="taxDia" width="80%" :show-close="taxShowClose" class="tax-margin" top="35vh">
                        <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">{{$t('taxesFees')}}</div>
                        <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{$t('taxesAndServiceFees')}}</div>
                        <div @click="taxDia = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">{{$t('close')}}</div>
                      </el-dialog>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.tax}}</span>
                    </div>
                  </div>
                  <!-- payableAtProperty -->
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.mandatoryFee !== ''">
                    <div style="float:left; height: 19px;line-height: 19px; vertical-align: middle;">
                      <span>{{$t('mandatoryFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.mandatoryFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.mandatoryTax !== ''">
                    <div style="float:left; height: 19px;line-height: 19px; vertical-align: middle;">
                      <span>{{$t('mandatoryTax')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.mandatoryTax}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.resortFee !== ''">
                    <div style="float:left; height: 19px;line-height: 19px; vertical-align: middle;">
                      <span>{{$t('resortFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.resortFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.cityFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('cityTaxFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.cityFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.destinationFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('destinationFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.destinationFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.serviceFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('serviceFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.serviceFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.CleaningFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('cleaningFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.CleaningFee}}</span>
                    </div>
                  </div>
                  <div :class="{'price-twoline': payAtHotel === true, 'price-oneline': payAtHotel === false}" v-if="orderData.administrativeFee !== ''">
                    <div style="float:left; height: 25px;">
                      <span>{{$t('administrativeFee')}}</span>
                      <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                    </div>
                    <div style="float:right;">
                      <span>{{orderData.administrativeFee}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="clear:both; font-size:16px; font-weight:650; height: 54px; padding: 0px 4.5%; line-height: 54px;">
                <div style="display:inline-block;float:left;">{{$t('totalPrice')}}</div>
                <div style="display:inline-block;float:right;">{{orderData.curMark}} {{orderData.totalPrice}}</div>
              </div>
              <div style="clear: both;font-size: 14px;font-weight: 320;height: 20px;padding: 0px 4.5%;line-height: 20px;" v-if="orderData.payAtProperty !== '' && patAtHotel === true">
                <div style="display:inline-block;float:left;">{{$t('payNow')}}</div>
                <div style="display:inline-block;float:right;">{{orderData.curMark}} {{orderData.payPrice}}</div>
              </div>
              <div style="clear:both; font-size:14px; font-weight:320; height: 54px; padding: 0px 4.5%; line-height: 54px;" v-if="orderData.payAtProperty !== '' && patAtHotel === true">
                <div style="display:inline-block;float:left;">{{$t('payableAtProperty')}}</div>
                <div style="display:inline-block;float:right;">{{orderData.payAtProperty}}</div>
              </div>
              <div v-if="orderData.discount != ''">
                <div class="coupon-info">
                  <img src="/static/img/order/u207.png" class="coupon-img">
                  <span style="margin-left: 5px">{{$t('couponUselargeMsg')}} {{orderData.curMark}} {{orderData.discount}}{{$t('point')}}</span>
                </div>
                <div style="margin: 8px 0px 10px 0px;font-size:12px;">
                  <span class="coupon-text">{{$t('couponUseshortMsg')}} {{orderData.discountCode}}</span>
                </div>
              </div>
              <div style="clear: both;font-size: 12px;font-weight: 340;padding: 0px 4.5%;height: 10px;" v-if="orderData.payAtProperty !== ''">
                <div style="display:inline-block;float:left;padding-bottom: 15px;">{{$t('priceDetailMsg')}}</div>
              </div>
            </div>
          </div>
          <!--左侧部分-->
          <div class="msg-left">
            <!--卡信息-->
            <form class="el-form demo-ruleForm">
              <!-- <div class="msg-guest">
                <div style="padding: 2px 4.5%;">
                  <el-tabs v-model="activeName">
                  电子支付
                  <el-tab-pane :label="$t('electronicPayment')" name="electronicPayment">
                    <div>
                      <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;display:inline-block;">
                      <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;">
                    </div>
                    <div>
                      <div class="long-margin">
                        <div class="msginfo-left">
                          <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username')}" ref="username" @blur="blurs('username')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('username')">
                              <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msginfo-right">
                          <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" v-model="cardNo" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardno')}" ref="cardno" @input="formatCardNumber" @blur="blurs('cardno')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('cardno')">
                              <span v-html="getLanguageHtml(cardNoError,'cardNoError')"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="padding-bottom:40px;">
                        <div class="msg-half-one">
                          <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" placeholder="MM/YY" :class="{'codeError':getSomeThing('effectivedate')}" ref="effectivedate" @blur="blurs('effectivedate')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('effectivedate')">
                              <span v-html="getLanguageHtml(effectiveDateError,'effectiveDateError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-half">
                          <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShowTwo}" ref="securityCodeTwo" @blur="blurs('securityCodeTwo')" @click="showCardRemindInfoTwo" @keyup.enter="closeCardRemind">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('securityCodeTwo')">
                              <span v-html="getLanguageHtml(securityCodeError,'securityCodeError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="cardremind" v-show="showCardRemindTwo">
                          <div class="remindimg">
                            <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                          </div>
                          <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                        </div>
                      </div>
                      <div style="height:30px;">
                        <el-checkbox v-model="checked">{{$t('rememberCard')}}</el-checkbox>
                      </div>
                    </div>
                  </el-tab-pane>
                  已存信用卡
                  <el-tab-pane :label="$t('mySavedCards')" name="saveCard" v-if="payment.status === '1'">
                    <div>
                      <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;" v-if="payment.type === '1'">
                      <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;" v-if="payment.type === '2'">
                    </div>
                    <div>
                      <div class="long-margin">
                        <div class="msginfo-left">
                          <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input is-disabled">
                              <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="payment.cardholder_name">
                            </div>
                          </div>
                        </div>
                        <div class="msginfo-right">
                          <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input is-disabled">
                              <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="payment.cardno">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="padding-bottom:80px;">
                        <div class="msg-half-one">
                          <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input is-disabled">
                              <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="payment.effectivedate">
                            </div>
                          </div>
                        </div>
                        <div class="msg-half">
                          <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShow}" ref="securityCode" @blur="blursCode('securityCode')" @click="showCardRemindInfo" @keyup.enter="closeCardRemind">
                            </div>
                            <div class="el-form-item__error" v-show="securityCodeShow">{{$t('validCVV')}}</div>
                          </div>
                        </div>
                        <div class="cardremind" v-show="showCardRemind">
                          <div class="remindimg">
                            <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                          </div>
                          <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  信用卡/借记卡
                  <el-tab-pane :label="$t('creditDebitCard')" name="newCard">
                    <div>
                      <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;display:inline-block;">
                      <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;">
                    </div>
                    <div>
                      <div class="long-margin">
                        <div class="msginfo-left">
                          <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username')}" ref="username" @blur="blurs('username')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('username')">
                              <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msginfo-right">
                          <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" v-model="cardNo" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardno')}" ref="cardno" @input="formatCardNumber" @blur="blurs('cardno')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('cardno')">
                              <span v-html="getLanguageHtml(cardNoError,'cardNoError')"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="padding-bottom:40px;">
                        <div class="msg-half-one">
                          <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" placeholder="MM/YY" :class="{'codeError':getSomeThing('effectivedate')}" ref="effectivedate" @blur="blurs('effectivedate')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('effectivedate')">
                              <span v-html="getLanguageHtml(effectiveDateError,'effectiveDateError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-half">
                          <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShowTwo}" ref="securityCodeTwo" @blur="blurs('securityCodeTwo')" @click="showCardRemindInfoTwo" @keyup.enter="closeCardRemind">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('securityCodeTwo')">
                              <span v-html="getLanguageHtml(securityCodeError,'securityCodeError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="cardremind" v-show="showCardRemindTwo">
                          <div class="remindimg">
                            <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                          </div>
                          <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                        </div>
                      </div>
                      <div style="height:30px;">
                        <el-checkbox v-model="checked">{{$t('rememberCard')}}</el-checkbox>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
                </div>
              </div> -->
              <div class="msg-right">
                <div class="advanceText">{{$t('payMethod')}}</div>
                <div class="advanceInfo">
                  <div>
                    <img v-for="item in paymentList" :key="item.value" :src="item.src" style="width:38px; height:25px; margin-right: 5px;">
                    <!-- <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px; margin-right: 5px;">
                    <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;"> -->
                  </div>
                  <div>
                    <div class="long-margin" style="margin-bottom: 20px;">
                      <div>
                        <div for="name" class="msg-name">{{$t('payMethod')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <el-select v-model="paymentOn" placeholder="请选择" @change="changePaymentMobile(paymentOn)" ref="paymentSelectMobile" class="paymentSelectMobile" style="width:100%">
                              <el-option
                                v-for="item in paymentMobileList"
                                :key="item.value"
                                :label="getLanguageHtml(item.value,'paymentLabel')"
                                :value="item.value" v-if="item.value !== 'saveCard' || (item.value === 'saveCard' && payment.total.status === '1')">
                                <span style="float: left"><img :src="item.src" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                <span style="float: left;" v-html="getLanguageHtml(item.value,'paymentLabel')"></span>
                                <span style="float: right" v-if="['saveCard', 'newCard'].includes(item.value)">
                                  <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;vertical-align: middle; margin-left: 5px;" v-if="item.value === 'newCard' || (item.value === 'saveCard' && payment.total.typeLs.includes('visa'))">
                                  <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;vertical-align: middle; margin-left: 5px;" v-if="item.value === 'newCard' || (item.value === 'saveCard' && payment.total.typeLs.includes('master'))">
                                </span>
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="long-margin" v-show="['paypal', 'alipay', 'wechat'].includes(paymentOn)">
                      <div>
                        <div for="name" class="msg-name"></div>
                        <div class="el-form-item__content">
                          <li style="line-height: 25px;font-size: 12px;" v-if="['paypal', 'alipay'].includes(paymentOn)">{{$t('youSelectPay')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabel')" style="font-weight: 400;color: #5392F9;"></span>{{$t('youWillBeForwardedTo')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabel')" style="font-weight: 400;color: #5392F9;"></span>{{$t('websiteToProceedWithThisTransaction')}}</li>
                          <li style="line-height: 25px;font-size: 12px;">{{$t('theTotalAmountYouChanged')}} <span style="font-weight: 400;color: #5392F9;">{{orderData.diffPrice}}</span></li>
                        </div>
                      </div>
                    </div>
                    <div class="long-margin" v-show="['saveCard'].includes(paymentOn)">
                      <div class="long-margin">
                        <div class="msginfo-right">
                          <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <el-select v-model="paymentCardno" placeholder="请选择" @change="changePaymentCardnoMobile(paymentCardno)" ref="paymentCardnoMobile" class="paymentCardnoMobileClass" style="width:100%">
                                <el-option
                                  v-for="item in payment.list"
                                  :key="item.sign"
                                  :label="item.cardno"
                                  :value="item.sign">
                                  <span style="float: left" v-if="item.type === 'visa'"><img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                  <span style="float: left" v-if="item.type === 'master'"><img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                  <span style="float: left;" v-html="item.cardno"></span>
                                </el-option>
                              </el-select>
                            </div>
                          </div>
                        </div>
                        <div class="msginfo-left">
                          <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input is-disabled">
                              <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoName">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="padding-bottom:80px; position: relative;height: 20px;">
                        <div class="msg-half" style="width: 46%;position: absolute;">
                          <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input is-disabled">
                              <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoEffectivedate">
                            </div>
                          </div>
                        </div>
                        <div class="msg-half" style="width: 46%;position: absolute;right: 0px;">
                          <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShow}" ref="securityCode" @blur="blursCode('securityCode')" @click="showCardRemindInfo" @keyup.enter="closeCardRemind">
                            </div>
                            <div class="el-form-item__error" v-show="securityCodeShow">{{$t('validCVV')}}</div>
                          </div>
                        </div>
                        <div class="cardremind" v-show="showCardRemind">
                          <div class="remindimg">
                            <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                          </div>
                          <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="long-margin" v-show="['newCard'].includes(paymentOn)">
                      <div class="long-margin">
                        <div class="msginfo-left">
                          <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username')}" ref="username" @blur="blurs('username')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('username')">
                              <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msginfo-right">
                          <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" v-model="cardNo" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardno'), 'paymentCardnoMobileClass': true}" ref="cardno" @input="formatCardNumber" @blur="blurs('cardno')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('cardno')">
                              <span v-html="getLanguageHtml(cardNoError,'cardNoError')"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="padding-bottom:40px;position: relative;">
                        <div class="msg-half">
                          <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" placeholder="MM/YY" :class="{'codeError':getSomeThing('effectivedate')}" ref="effectivedate" @blur="blurs('effectivedate')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('effectivedate')">
                              <span v-html="getLanguageHtml(effectiveDateError,'effectiveDateError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-half">
                          <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShowTwo}" ref="securityCodeTwo" @blur="blurs('securityCodeTwo')" @click="showCardRemindInfoTwo" @keyup.enter="closeCardRemind">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('securityCodeTwo')">
                              <span v-html="getLanguageHtml(securityCodeError,'securityCodeError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="cardremind" v-show="showCardRemindTwo">
                          <div class="remindimg">
                            <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                          </div>
                          <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                        </div>
                      </div>
                      <div style="height:30px;">
                        <el-checkbox v-model="checked">{{$t('rememberCard')}}</el-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--完成预定-->
              <div class="msg-guest">
                <div class="tonext">
                  <p class="remind-font" v-if="language === 'en'"><span v-html="$t('buttonMeansYouAgree')"></span>
                    <a class="remind-text" @click="clauseDialog = true">{{$t('termsUse')}}</a> {{$t('and')}}
                    <a class="remind-text" @click="policyDialog = true">{{$t('privacyPolicy')}}</a>
                  </p>
                  <p class="remind-font" v-else><span v-html="$t('buttonMeansYouAgree')"></span><a class="remind-text" @click="clauseDialog = true">{{$t('termsUse')}}</a>{{$t('and')}}<a class="remind-text" @click="policyDialog = true">{{$t('privacyPolicy')}}</a>
                  </p>
                  <p style="font-size:12px; font-weight:500; color: #2F7000;line-height: 17px;" v-if="cancelData !== 0">
                    <img src="https://res.roompai.com/static/img/order/2F7000.png" style="width:17px; height:17px;vertical-align: text-bottom;">{{$t('mobileRiskFreeOne')}}<br>
                    <span v-if="language === 'en'">{{$t('mobileRiskFreeTwo')}} </span>
                    <span v-else>{{$t('mobileRiskFreeTwo')}}</span>
                    <span v-html="getLanguageHtml(orderData.cancelData,'cancelData')"></span> {{$t('noCancelFeeBefore')}}
                  </p>
                  <p class="surplus-room" v-if="orderData.remainrooms === '1'">{{$t('onlyLast')}} 1 {{$t('onOurSite')}}</p>
                  <el-button class="order_button" @click="JumpOver">{{$t('bookNow')}}</el-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
  <frameRenews :frameRenewDialog="frameRenewDialog"></frameRenews>
  <mobilepolicy :policyDialog="policyDialog" @getPolicyDia="getPolicyDia"></mobilepolicy>
  <mobileclause :clauseDialog="clauseDialog" @getClauseDia="getClauseDia"></mobileclause>
  <frameToolongChildOrder :frameToolongChildOrderDialog="frameToolongChildOrderDialog"></frameToolongChildOrder>
</el-container>
</template>
<script>
import { writeChildPayShow, writeChildPayFinishBook, orderChildPayment, wechatJsPayGetSign } from '@/request/order.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import frameRenews from '@/components/public/frameRenews'
import mobilepolicy from '@/components/question/mobilepolicy'
import mobileclause from '@/components/question/mobileclause'
import paypalButton from '@/components/order/paypalButton'
import frameToolongChildOrder from '@/components/public/frameToolongChildOrder'
export default {
  name: 'WriteChildPay',
  components: {
    publicFooter,
    publicHeader,
    frameRenews,
    mobilepolicy,
    mobileclause,
    frameToolongChildOrder,
    paypalButton
  },
  data () {
    return {
      curPageData: 'WriteChildPay',
      hotel: {},
      orderData: {'night': {'zh': 1, 'en': 1}, 'roomNum': {'zh': 1, 'en': 1}, 'cancel': {'zh': '', 'en': ''}},
      checkData: {},
      payment: {'total': {'status': '0'}},
      payment_card_show: false,
      paymentCardno: '0',
      paymentCardnoName: '',
      paymentCardnoEffectivedate: '',
      paymentCardnoValidCVV: '',
      someArray: [],
      cancelData: 0,
      remainTime: 0,
      activeName: 'electronicPayment',
      securityCodeShow: false,
      showCardRemind: false,
      securityCodeShowTwo: false,
      showCardRemindTwo: false,
      userNameError: 'appearsOnTheCard',
      cardNoError: 'validCardNumber',
      effectiveDateError: 'pleaseValidCardExpiry',
      securityCodeError: 'validCVV',
      hour: '',
      minute: '',
      second: '',
      promiseTimer: '',
      frameRenewDialog: false, // 刷新
      homeSurplus: 3,
      cardNo: '',
      screenWidth: 0,
      risePrice: '12.5',
      currencyShow: false, // 币种是否显示
      orderPayPageTime: 300,
      language: this.common.languageSet(this),
      ismobile: false,
      taxWidth: 327,
      taxDia: false,
      taxShowClose: false,
      checked: false,
      elementWidth: document.documentElement.clientWidth,
      stepWidth: document.documentElement.clientWidth - 20,
      lineWidth: 98,
      lineOneLeft: 48,
      lineTwoLeft: 196,
      policyDialog: false,
      clauseDialog: false,
      wechatEject: false, // 微信弹出
      wechatShowClose: false,
      frameToolongChildOrderDialog: false,
      timeZone: 0,
      weChatImgUrl: '',
      // , {'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}, {'value': 'alipay', 'label_zh': '支付宝', 'label_en': 'Alipay', 'src': '/static/img/order/alipay.png'}
      paymentList: [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}],
      // , {'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}, {'value': 'alipay', 'label_zh': '支付宝', 'label_en': 'Alipay', 'src': '/static/img/order/alipay.png'}
      paymentMobileList: [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'saveCard', 'label_zh': '已存信用卡', 'label_en': 'My saved cards', 'src': 'https://res.roompai.com/static/img/order/orderPay-CVV.svg'}, {'value': 'newCard', 'label_zh': '信用卡/借记卡', 'label_en': 'Credit/debit card', 'src': 'https://res.roompai.com/static/img/order/orderPay-CVV.svg'}],
      paymentOn: 'paypal',
      payOrdernoClick: false,
      mainMinHeight: document.documentElement.clientHeight - 60 - 241,
      source: 'roompai',
      wechatH5Status: '',
      payAtHotel: true
    }
  },
  created () {
    var width = document.documentElement.clientWidth
    this.taxWidth = width - 40
    if (this.common.languageSet(this) === 'zh') {
      this.lineWidth = (width - 164) / 2
      this.lineOneLeft = 48
      this.lineTwoLeft = this.lineWidth + 96
    } else {
      this.lineWidth = (width - 260) / 2 + 32 // (屏幕宽度 - 左右两侧间距20 - 步骤宽度80*3)/2 = 剩余横线宽度 + 左右延申宽度*2：(整体宽度80-图标25)/2 = 两侧宽度-11.5*2
      this.lineOneLeft = 64 // (整体宽度80-图标25)/2 = 两侧宽度 + 25 = 左侧+图标宽度 + 缝隙11.5
      this.lineTwoLeft = this.lineOneLeft + this.lineWidth + 48 // 第一条线偏移度 + 第一条线长度 + 缝隙11.5:和中文一致*2 + 图标宽度25
    }
  },
  mounted () {
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    // 页面展示
    var orderno = this.common.linkQuerys.orderno
    if (orderno === undefined || orderno === null || orderno === 'undefined' || orderno === 'null') {
      // this.$router.push({name: 'PayDisabled', query: {'source': this.source}})
      let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      this.$router.push({name: 'PayDisabled', params: {'querys': newQuerys}})
    } else {
      this.writeChildOrderPayPageShow()
    }
    var token = localStorage.getItem('token')
    if (token === undefined || token === null || token === 'null') {
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)
      // this.$router.push({name: 'login', query: {'source': this.source}})
      let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      this.$router.push({name: 'login', params: {'querys': newQuerys}})
    }
    var that = this
    if (this.remainTime > 0) {
      this.hour = Math.floor(this.remainTime / 3600)
      this.minute = Math.floor((this.remainTime / 60) % 60)
      this.second = Math.floor(this.remainTime % 60)
      this.countDowm()
    }

    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }

    // 微信js支付 config获取签名
    var wechatJsPayConf = this.common.encryptionData([], this)
    if (wechatJsPayConf.ua.indexOf('MicroMessenger') !== -1) {
      this.wechatJsSign()
    }

    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }

    // 监听点击事件
    document.addEventListener('click', function (e) {
      var cardRemindShow = true
      for (var i = 0; i < e.target.classList.length; i++) {
        //  && !e.target.classList.indexOf('cardremind')
        if (e.target.classList[i] === 'cardRemindShow') {
          cardRemindShow = false
        }
      }
      if (cardRemindShow) {
        that.showCardRemind = false
        that.showCardRemindTwo = false
      }
    })
    this.getKeyboard()

    //  默认电子支付方式
    if (location.host === 'www.roompai.com') {
      this.paymentOn = 'wechat'
      if (this.source === 'sec') {
        this.paymentList = [{'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}]
        this.paymentMobileList = [{'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}]
      }
    } else if (location.host === 'us.roompai.com') {
      this.paymentOn = 'paypal'
      if (this.common.isMobile()) {
        this.paymentMobileList = [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}]
      }
      if (this.source === 'sec') {
        this.paymentList = [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}]
        this.paymentMobileList = [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}]
      }
    } else if (location.host === 'localhost:8080' || location.host === 'localhost:8081') {
      this.paymentOn = 'wechat'
      if (this.common.isMobile()) {
        this.paymentMobileList = [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}]
      }
      if (this.source === 'sec') {
        this.paymentList = [{'value': 'wechat', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}]
        this.paymentMobileList = [{'value': 'wechat', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}]
      }
    }

    // 默认电子支付
    if (this.common.isMobile() === false) {
      this.changePayment(this.paymentOn)
    } else {
      this.changePaymentMobile(this.paymentOn)
    }

    setInterval(function () {
      if (that.payment.total.status === '1' && that.paymentCardno === '0') {
        for (let index in that.payment.list) {
          that.paymentCardno = that.payment.list[index].sign

          if (that.common.isMobile() === false) {
            that.changePaymentCardno(that.paymentCardno)
          } else {
            that.changePaymentCardnoMobile(that.paymentCardno)
          }
          return false
        }
      }
    }, 1000)
    // 如果是微信 授权登录成功，则直接调起支付
    var payOrder = this.common.linkQuerys.payOrder
    if (payOrder === 'now') {
      this.paymentOn = 'wechat'
      this.JumpOver()
    }
    // 微信支付 切换回来 要
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy () {
    clearInterval(this.wechatH5Status)

    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    window.removeEventListener('blur', this.handleBlur)
    window.removeEventListener('focus', this.handleFocus)
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1000) {
        this.ismobile = true
      } else {
        this.ismobile = false
      }
    },
    language: function (newCur, oldCur) {
      this.writeChildOrderPayPageShow()
    }
  },
  methods: {
    getKeyboard () {
      var u = navigator.userAgent
      // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      // if (isAndroid) {
      //   var windowHeight = window.innerHeight
      //   window.addEventListener('resize', () => {
      //     var newwindowHeight = window.innerHeight
      //     if (windowHeight > newwindowHeight + 100) {
      //       this.showCardRemind = true
      //       this.showCardRemindTwo = true
      //     } else {
      //       this.showCardRemind = true
      //       this.showCardRemindTwo = true
      //     }
      //   })
      // }
      if (isiOS) {
        window.addEventListener('focusin', () => {
          this.showCardRemind = true
          this.showCardRemindTwo = true
        }, true)
        window.addEventListener('focusout', () => {
          this.showCardRemind = false
          this.showCardRemindTwo = false
        }, true)

        // 手机端设置支付方式 不显示 false
        var paymentSelectMobile = document.querySelector('.paymentSelectMobile')
        paymentSelectMobile.addEventListener('focusin', () => {
          this.showCardRemind = false
          this.showCardRemindTwo = false
        }, true)

        // 手机端设置支付方式 不显示 false
        var paymentCardnoMobile = document.querySelector('.paymentCardnoMobileClass')
        paymentCardnoMobile.addEventListener('focusin', () => {
          this.showCardRemind = false
          this.showCardRemindTwo = false
        }, true)
      }
    },
    hotelLanguage (language) {
      this.language = language
    },
    writeChildOrderPayPageShow: function () {
      var that = this
      let locationHref = window.document.location.href
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var orderno = this.common.linkQuerys.orderno
      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      // 订单信息填写数据
      var orderDataJson = {
        'token': token,
        'time': time,
        'orderno': orderno,
        'currency': currency,
        'operation': 'writeChildPayShow'
      }
      var orderDataShow = this.common.encryptionData(orderDataJson, this)
      writeChildPayShow(orderDataShow).then(res => {
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          // this.$router.push({name: 'login', query: {'source': this.source}})
          let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '003' || res.flag === '004' || res.flag === '165') {
          // this.$router.push({name: 'PayDisabled', query: {'source': this.source}})
          let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          this.$router.push({name: 'PayDisabled', params: {'querys': newQuerys}})
        } else {
          if (res.data.orderData.orderPayPageTime !== 0) {
            this.remainTime = res.data.orderData.orderPayPageTime
          }
          this.hour = Math.floor(this.remainTime / 3600)
          this.minute = Math.floor((this.remainTime / 60) % 60)
          this.second = Math.floor(this.remainTime % 60)
          this.countDowm()
          // 信息
          this.hotel = res.data.hotel
          this.cancelData = res.data.orderData.cancelData.en
          this.homeSurplus = res.data.orderData.remainrooms
          this.orderData = res.data.orderData
          this.checkData = res.data.ischeck
          this.payment = res.data.payment
          this.paymentList = res.data.thirdParty.pc
          this.paymentMobileList = res.data.thirdParty.mobile
          this.paymentOn = res.data.thirdParty.pc['0'].value
          this.payAtHotel = this.orderData.payAtHotel

          if (this.common.isMobile() === false) {
            this.changePayment(this.paymentOn)
          } else {
            this.changePaymentMobile(this.paymentOn)
          }
          if (res.data.payment.total.status === '0') {
            that.activeName = 'electronicPayment'
          }
        }
      })
    },
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }

      var getLanguage = this.common.languageSet(this)
      if (['hotelname', 'hoteladdress'].includes(type)) {
        var typeLan = type + '_' + getLanguage
        return data[typeLan]
      } else if (['roomName', 'checkin', 'checkout', 'night', 'roomNum', 'person', 'child', 'bedType', 'breakfast', 'cancel', 'cancelData', 'breakfast_num'].includes(type)) {
        if (getLanguage === 'zh') {
          if (type === 'roomName') {
            if (data.zh === '') {
              return data.en
            }
          }
          return data.zh
        } else {
          return data.en
        }
      } else if (['userLastNameError', 'userNameError', 'cardNoError', 'effectiveDateError', 'securityCodeError', 'emailError', 'telError', 'emailConfirmError', 'paymentLabel'].includes(type)) {
        if (data === 'newCard') {
          data = 'creditDebitCard'
        }
        if (data === 'saveCard') {
          data = 'mySavedCards'
        }
        return this.$t(data)
      }
    },
    formatCardNumber (e) {
      const input = e.target
      const cursorIndex = input.selectionStart
      const lineNumOfCursorLeft = (e.target.value.slice(0, cursorIndex).match(/\s/g) || []).length
      const noLine = e.target.value.replace(/\s/g, '')
      const newCardNum = noLine.replace(/\D+/g, '').replace(/(\d{4})/g, '$1 ').replace(/\s$/, '')
      const newLineNumOfCursorLeft = (newCardNum.slice(0, cursorIndex).match(/\s/g) || []).length
      const newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft
      this.$nextTick(() => {
        this.cardNo = newCardNum
        this.$nextTick(() => {
          input.selectionStart = newCursorIndex
          input.selectionEnd = newCursorIndex
        })
      })
    },
    blursCode (refInfo) {
      var refName = this.$refs[refInfo].value
      if (refName === '' || refName === null) {
        this.securityCodeShow = true
      } else {
        if (refName.length !== 3) {
          this.securityCodeShow = true
        } else {
          this.securityCodeShow = false
        }
      }
    },
    showCardRemindInfo () {
      this.showCardRemind = true
    },
    showCardRemindInfoTwo () {
      this.showCardRemindTwo = true
    },
    JumpOver: function () {
      // 点击支付订单 后关闭下次点击
      if (this.payOrdernoClick === true) {
        // 如果微信PC支付 则 需要弹框
        if (this.paymentOn === 'wechat' && this.weChatImgUrl !== '') {
          this.wechatEject = true
        }
        return false
      }
      this.payOrdernoClick = true

      this.showCardRemind = false
      this.showCardRemindTwo = false
      let locationHref = window.document.location.href

      if (this.common.isMobile() === true) {
        if (!['saveCard', 'newCard'].includes(this.paymentOn)) {
          this.activeName = 'electronicPayment'
        }
      }

      var securityCode = ''
      var cardno = ''
      var effectivedate = ''
      var securityCodeTwo = ''
      var username = ''
      if (['saveCard', 'newCard'].includes(this.activeName)) {
        if (this.activeName === 'saveCard') {
          this.$options.methods.blursCode.bind(this)('securityCode')
          if (this.securityCodeShow === true) {
            this.$refs['securityCode'].focus()
            return false
          }
          securityCode = this.$refs['securityCode'].value
        } else if (this.activeName === 'newCard') {
          // this.inputInfo.forEach((item) => {
          //   this.$options.methods.blurs.bind(this)(item)
          //   let result = this.$options.methods.getSomeThing.bind(this)(item)
          //   if (result === true) {
          //     this.$refs[item].focus()
          //     return false
          //   }
          // })
          this.$options.methods.blurs.bind(this)('username')
          let username = this.$options.methods.getSomeThing.bind(this)('username')
          if (username === true) {
            this.$refs['username'].focus()
            return false
          }
          this.$options.methods.blurs.bind(this)('cardno')
          let cardno = this.$options.methods.getSomeThing.bind(this)('cardno')
          if (cardno === true) {
            this.$refs['cardno'].focus()
            return false
          }
          this.$options.methods.blurs.bind(this)('effectivedate')
          let effectivedate = this.$options.methods.getSomeThing.bind(this)('effectivedate')
          if (effectivedate === true) {
            this.$refs['effectivedate'].focus()
            return false
          }
          this.$options.methods.blurs.bind(this)('securityCodeTwo')
          let securityCodeTwo = this.$options.methods.getSomeThing.bind(this)('securityCodeTwo')
          if (securityCodeTwo === true) {
            this.$refs['securityCodeTwo'].focus()
            return false
          }
        }

        // 支付信息
        if (this.activeName === 'newCard') {
          username = this.$refs['username'].value
          cardno = this.$refs['cardno'].value
          effectivedate = this.$refs['effectivedate'].value
          if (cardno.length >= 20) {
            this.$refs['cardno'].focus()
            return false
          }
          if (effectivedate.length >= 6) {
            this.$refs['effectivedate'].focus()
            return false
          }
        }
        securityCodeTwo = this.$refs['securityCodeTwo'].value
        if (securityCodeTwo.length >= 4) {
          this.$refs['securityCodeTwo'].focus()
          return false
        }
      }

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var orderno = this.common.linkQuerys.orderno
      // 订单信息填写数据
      var orderFinishBookJson = {
        'token': token,
        'activeName': this.activeName,
        'securityCode': securityCode,
        'username': username,
        'cardno': cardno,
        'effectivedate': effectivedate,
        'securityCodeTwo': securityCodeTwo,
        'paymentInfo': this.paymentCardno,
        'orderno': orderno,
        'rememberCard': this.checked,
        'currency': currency,
        'time': time,
        'paymentOn': this.paymentOn,
        'operation': 'writeChildPayFinishBook'
      }
      var orderFinishBook = this.common.encryptionData(orderFinishBookJson, this)
      writeChildPayFinishBook(orderFinishBook).then(res => {
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          // this.$router.push({name: 'login', query: {'source': this.source}})
          let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '005') {
          // 安全码错误
          this.securityCodeShow = true
          this.$refs['securityCode'].focus()
        } else if (res.flag === '007' || res.flag === '114' || res.flag === '165') {
          // this.$router.push({name: 'PayDisabled', query: {'source': this.source}})
          let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          this.$router.push({name: 'PayDisabled', params: {'querys': newQuerys}})
        } else if (res.flag === '200') {
          if (this.activeName !== 'electronicPayment') {
            var orderResultData = {
              'hotelid': res.data.hotelid,
              'checkin': res.data.checkin,
              'checkout': res.data.checkout,
              'room': res.data.room,
              'adult': res.data.adult,
              'child': res.data.child,
              'childNums': res.data.childNums,
              'source': this.source,
              'orderno': res.data.orderno,
              'parentorderno': res.data.parent_orderno,
              'flag': res.flag
            }
            localStorage.setItem('orderResultData', JSON.stringify(orderResultData))
            // this.$router.push({name: 'PayResult', params: orderResultData})
            let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
            orderResultData['querys'] = newQuerys
            this.$router.push({name: 'PayResult', params: orderResultData})
          } else {
            var orderInfoData = {
              'hotelid': res.data.hotelid,
              'product': res.data.product,
              'checkin': res.data.checkin,
              'checkout': res.data.checkout,
              'room': res.data.room,
              'adult': res.data.adult,
              'child': res.data.child,
              'childNums': res.data.childNums,
              'source': this.source,
              'orderno': res.data.orderno,
              'parentorderno': res.data.parent_orderno,
              'paymentOn': this.paymentOn,
              'paymentSkipUrl': res.data.url
            }
            localStorage.setItem('orderData', JSON.stringify(orderInfoData))

            // wechat 区分与其他的支付
            if (this.paymentOn === 'wechat' && orderFinishBook.ua.indexOf('MicroMessenger') !== -1) { // 微信自带浏览器 支付
              this.frameRenewDialog = true
              // this.wechatH5Polling()
              // 微信js支付
              console.log(res.data.payRequest)
              this.wxJsPay(res.data.payRequest)
            } else if (this.paymentOn === 'wechat' && orderFinishBook.flag === 'website') { // 微信PC 支付
              this.wechatEject = true
              var time = parseInt(new Date().getTime() / 1000) + ''
              this.weChatImgUrl = res.data.url + '?' + time
            } else if (this.paymentOn === 'wechat' && orderFinishBook.flag === 'mobile') { // 微信h5 支付
              this.frameRenewDialog = true
              this.wechatPayCallback = 1
              this.wechatH5Polling()
              window.location.href = res.data.url
            } else {
              // this.$router.push({name: 'Waiting', params: orderInfoData})
              let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
              orderInfoData['querys'] = newQuerys
              this.$router.push({name: 'Waiting', params: orderInfoData})
            }
          }
        }
      })
    },
    // 微信手机支付 轮询 支付状态 跳转到回调页面
    wechatH5Polling: function () {
      var that = this
      var num = 0
      // 如果没有遮罩层 则添加遮罩层
      if (this.frameRenewDialog !== true) {
        this.frameRenewDialog = true
      }
      if (this.wechatH5Status !== '') {
        return false
      }

      // 0.5 秒请求一次 5秒钟跳转结果页面
      this.wechatH5Status = setInterval(function () {
        // h5支付 大于20秒则跳转到支付结果页面
        if (num >= 10) {
          that.wechatJumpOver()
          clearInterval(this.wechatH5Status)
          this.wechatH5Status = ''
        }

        // 查询当前订单状态
        var params = that.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }

        var language = that.common.languageSet(that)
        var currency = that.common.currencySet(that)
        var time = parseInt(new Date().getTime() / 1000)
        var sessionid = that.common.sessionidGet(that)

        // 验证verify
        var token = that.$md5('0' + that.common.lfSignKey)
        if (localStorage.getItem('token')) {
          token = localStorage.getItem('token')
        }
        var payData = {
          'token': token,
          'hotelid': params.hotelid,
          'checkin': params.checkin,
          'checkout': params.checkout,
          'room': params.room,
          'adult': params.adult,
          'child': params.child,
          'childNums': params.childNums,
          'source': params.source,
          'orderno': params.orderno,
          'parentorderno': params.parentorderno,
          'language': language,
          'currency': currency,
          'sessionid': sessionid,
          'paymentOn': that.paymentOn,
          'operation': 'paymentChildOrderData',
          'time': time
        }

        var payDataJson = that.common.encryptionData(payData, that)
        orderChildPayment(payDataJson).then(res => {
          if (res.flag === '200') {
            if (res.data.payStatus === 'finish') {
              that.wechatJumpOver()
              clearInterval(this.wechatH5Status)
              this.wechatH5Status = ''
            }
          }
        })

        num++
      }, 1000)
    },
    // 微信支付 回调
    wechatJumpOver: function () {
      // 如果没有遮罩层 则添加遮罩层
      if (this.frameRenewDialog !== true) {
        this.frameRenewDialog = true
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      var time = parseInt(new Date().getTime() / 1000)
      var orderno = this.orderData.childorderno
      var parentorderno = this.orderData.orderno
      window.location.href = '/api/orderBook?operation=paymentChildCallback&payType=wechat&time=' + time + '&roompaiOrderno=' + orderno + '&parentorderno=' + parentorderno + '&source=' + this.orderData.source + '&user_token=' + token
    },
    // 微信js支付签名
    wechatJsSign: function () {
      var that = this

      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      } else {
        return false
      }

      var time = parseInt(new Date().getTime() / 1000)
      var payData = {
        'url': window.location.href.split('#')[0],
        'orderno': params.orderno,
        'operation': 'wechatJsPayGetSign',
        'time': time
      }
      var payDataJson = this.common.encryptionData(payData, this)
      wechatJsPayGetSign(payDataJson).then(res => {
        const config = res.data
        that.wx.config({
          debug: false,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: ['chooseWXPay', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo']
        })
      })
    },
    // 微信js支付
    wxJsPay: function (payRequest) {
      var that = this
      this.wx.ready(function () {
        that.wx.chooseWXPay({
          appId: payRequest.appId,
          timestamp: payRequest.timeStamp,
          nonceStr: payRequest.nonceStr,
          package: payRequest.package,
          signType: payRequest.signType,
          paySign: payRequest.paySign,
          success: function (res) {
            // 支付成功的回调函数
            console.log('-------成功------')
            that.wechatJumpOver()
          },
          fail: function (res) {
            // 支付失败的回调函数
            console.log('-------失败------')
            that.wechatJumpOver()
          },
          cancel: function (res) {
            // 用户取消支付的回调函数
            console.log('------取消-------')
            that.frameRenewDialog = false
          }
        })
      })
    },
    blurs (refInfo) {
      var refName = this.$refs[refInfo].value
      if (refName === '' || refName === null) {
        this.$set(this.someArray, refInfo, true)
      } else {
        if (refInfo === 'securityCodeTwo' && refName.length !== 3) {
          this.$set(this.someArray, refInfo, true)
        } else {
          this.$set(this.someArray, refInfo, false)
        }
      }
    },
    getSomeThing (index) { // 返回数组元素
      return this.someArray[index]
    },
    countDowm () {
      var self = this
      clearInterval(this.promiseTimer)
      this.promiseTimer = setInterval(function () {
        if (self.hour !== 0 && self.minute === 0 && self.second === 0) {
          self.hour -= 1
          self.minute = 59
          self.second = 59
        } else if (self.minute !== 0 && self.second === 0) {
          self.second = 59
          self.minute -= 1
        } else if (self.hour === 0 && self.minute === 0 && self.second === 0) {
          self.second = 0
          self.$emit('countDowmEnd', true)
          clearInterval(self.promiseTimer)
          // self.frameDialog = true
          self.$router.push({name: 'PayDisabled', query: {'source': this.source}})
        } else {
          self.second -= 1
        }
        // 15分钟没点击，则刷新页面，且刷新计时
        if (self.timeZone < 900) {
          self.timeZone += 1
        } else if (self.timeZone === 900) {
          self.frameToolongChildOrderDialog = true
        }
      }, 1000)
    },
    formatNum (num) {
      return num < 10 ? '0' + num : '' + num
    },
    closeCardRemind () {
      this.showCardRemind = false
      this.showCardRemindTwo = false
    },
    getPolicyDia (val) {
      this.policyDialog = val
    },
    getClauseDia (val) {
      this.clauseDialog = val
    },
    changePayment (scope) {
      let brand = scope
      for (let index in this.paymentList) {
        let aa = this.paymentList[index]
        let value = aa.value
        if (brand === value) {
          this.$refs.paymentSelect.$el.children[0].children[0].setAttribute('style', 'background:url(' + aa.src + ') no-repeat 20px;background-size: 38px 25px;color: #333;padding-left: 70px;')
        }
      }
    },
    changePaymentMobile (scope) {
      let brand = scope
      for (let index in this.paymentMobileList) {
        let aa = this.paymentMobileList[index]
        let value = aa.value
        if (brand === value) {
          this.activeName = value
          this.$refs.paymentSelectMobile.$el.children[0].children[0].setAttribute('style', 'background:url(' + aa.src + ') no-repeat 20px;background-size: 38px 25px;color: #333;padding-left: 70px;')
        }
      }
    },
    changePaymentCardno (cardno) {
      for (let index in this.payment.list) {
        let aa = this.payment.list[index]
        let sign = aa.sign
        if (cardno === sign) {
          // var urlsrc = ''
          // if (aa.type === 'visa') {
          //   urlsrc = 'https://res.roompai.com/static/img/order/visa.png'
          // }
          // if (aa.type === 'master') {
          //   urlsrc = 'https://res.roompai.com/static/img/order/mastercard.png'
          // }
          // this.$refs.paymentCardno.$el.children[0].children[0].setAttribute('style', 'background:url(' + urlsrc + ') no-repeat 20px;background-size: 38px 25px;color: #333;padding-left: 70px;')

          this.paymentCardnoName = aa.cardholder_name
          this.paymentCardnoEffectivedate = aa.effectivedate
          this.paymentCardnoValidCVV = aa.effectivedate
        }
      }
    },
    changePaymentCardnoMobile (cardno) {
      for (let index in this.payment.list) {
        let aa = this.payment.list[index]
        let sign = aa.sign
        if (cardno === sign) {
          var urlsrc = ''
          if (aa.type === 'visa') {
            urlsrc = 'https://res.roompai.com/static/img/order/visa.png'
          }
          if (aa.type === 'master') {
            urlsrc = 'https://res.roompai.com/static/img/order/mastercard.png'
          }
          this.$refs.paymentCardnoMobile.$el.children[0].children[0].setAttribute('style', 'background:url(' + urlsrc + ') no-repeat 20px;background-size: 38px 25px;color: #333;padding-left: 70px;')

          this.paymentCardnoName = aa.cardholder_name
          this.paymentCardnoEffectivedate = aa.effectivedate
          this.paymentCardnoValidCVV = aa.effectivedate
        }

        this.showCardRemind = false
        this.showCardRemindTwo = false
      }
    },
    handleVisibilityChange () {
      if (document.hidden) {
        // 用户切换到其他应用程序或设备主屏幕
        console.log('handleVisibilityChange 用户切换到其他页面')
      } else {
        // 用户回到当前应用程序
        console.log('handleVisibilityChange 用户回到当前页面')

        var paymentOn = ''
        var orderData = localStorage.getItem('orderData')
        if (orderData !== '{}') {
          var params = JSON.parse(orderData)
          if (params.hasOwnProperty('paymentOn')) {
            paymentOn = params.paymentOn
          }
        }
        var orderBookVisibityChange = this.common.encryptionData({'ss': '1'}, this)
        if (paymentOn === 'wechat' && orderBookVisibityChange.flag === 'mobile' && orderBookVisibityChange.ua.indexOf('MicroMessenger') === -1) {
          console.log('handleVisibilityChange weixin支付')
          this.wechatH5Polling()
        }
      }
    }
  },
  computed: {
    hourString () {
      return this.formatNum(this.hour)
    },
    minuteString () {
      return this.formatNum(this.minute)
    },
    secondString () {
      return this.formatNum(this.second)
    }
  }
}
</script>
  <style scoped>
  .main{background-color: #fff;height:auto; margin:90px auto auto;width:1100px;}
  .blue-txt{color: rgb(83, 146, 249) !important;}
  /* 步骤条 */
  .stepinfo{text-align: center;margin: 30px auto; width: 100%;}
  .el-step.is-center .el-step__line{left:20%; right:2%;background-color:#4F4C4C; height: 1px;top:14.5px;}
  .el-step.is-center .step-two-zh{margin-right: 0px;left: 20%;right: 2%;}
  .el-step.is-center .step-two-en{margin-right: 0px;left: 41%;right: 2%;}
  .el-step.is-center .step-one-zh{margin-right: 0px;right: 2%;left: 20%;}
  .el-step.is-center .step-one-en{margin-right: 0px;right: 2%;left: 35%;}
  .step-img{width: 30px;height: 30px;vertical-align:middle;}
  .step-text{color:#4F4C4C;font-size: 14px; font-weight: 600;}
  .order-step{width: 497px; margin-right: 0px;}
  .div-hidden{display:none}
  /* 左侧开始 */
  .msg-left{ width:736px;display:inline-block;float:left; margin-right:12px;}
  /* 文字部分 */
  .msg-pink{height:50px; color:#F56C6C;font-size: 14px;background-color: rgba(254, 240, 240, 1);border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);}
  .pink-back{border:none; width:50px; height:50px; background-color:rgba(245, 108, 108, 1);vertical-align:middle;}
  .pink-logo, .green-logo{width: 30px;height: 30px; float:left; margin: 10px;}
  .msg-pink div, .msg-green div{display:inline-block; float: left;}
  .pink-text{line-height:50px; height:50px; padding-left:10px;}
  .pink-maintext{font-weight:650; color:#F56C6C;}
  /* 时间倒计时 */
  .msg-green{height:50px;font-size: 14px; color:#E6A23C; background-color: rgba(240, 249, 235, 1);border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-top:10px;}
  .green-back{border:none; width:50px; height:50px; background-color:rgba(103, 194, 58, 1);vertical-align:middle;}
  .green-text{line-height:50px; height:50px; padding-left:10px; color:#67C23A;}
  /* 卡 */
  .msg-guest{border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-top:10px;padding-bottom:20px;padding-top: 20px;font-size:13px;color:#606266;}
  .el-tabs__nav{padding-left:10px;}
  .el-tabs__active-bar{ height:3px; width:45%; margin-left:10px;}
  .el-tabs__item{ font-size:14px; font-weight:650; width: 45%;}
  .msg-name{text-align: right;vertical-align: middle;float: left;font-size: 14px;color: #606266;line-height: 40px; padding: 0 12px 0 0;-webkit-box-sizing: border-box;box-sizing: border-box;}
  .el-input.is-disabled .el-input__inner{color:#797979;}
  .el-form-item__error{color:#E12D2D;}
  .el-input__inner:focus{ border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
  .cardremind{border-width: 0px;position: absolute;left: 50%;top: 45%;width: 207px;height: 158px;background: inherit;background-color: rgba(255, 255, 255, 1);border: none;border-radius: 0px;-moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451);-webkit-box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);}
  .remindimg{width:100%; height:80%;display: flex;justify-content: center;align-items: center;}
  .codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
  .msginfo-left{width:49%;display:inline-block;margin-right: 1%;}
  .msginfo-right{width:49%;display:inline-block;}
  .msg-half-one{width:23.5%;display:inline-block;margin-right: 1%;}
  .msg-half{width:23.5%;display:inline-block;}
  .long-margin{margin-bottom:60px;}
  .tonext{padding: 2px 20px; text-align:right;}
  .remind-text{color:#5392F9; font-weight:650;text-decoration:none;}
  .surplus-room{font-size:12px; color:#E12D2D;}
  /* 搜索 */
  .order_button,.order_button:focus{width:30%;height:51px;font-size:16px; font-weight:650; background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
  .order_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}
  /* 右侧部分 */
  .msg-right-all{width:352px; float: right;}
  .msg-right{width:100%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;}
  /* 评分 */
  .score-bar{width: 100%;-webkit-box-sizing: border-box;box-sizing: border-box;}
  .scoreNo{height: 6px;border-radius: 0px 4px 4px 0px;background-color: rgba(79, 76, 76, 1);overflow: hidden;position: relative;vertical-align: middle;}
  .scoreYes{height: 100%;border-radius: 0px;text-align: right;line-height: 1;white-space: nowrap;-webkit-transition: width .6s ease;transition: width .6s ease;background-color:rgba(252, 210, 5, 1);}
  /* 预订信息 */
  .advanceText{font-size:18px; font-weight:650; border-bottom: 1px solid rgba(221, 223, 226, 1);height: 54px; line-height: 54px; padding:0px 4.5%;}
  .advanceInfo{ margin-top:13px;color:#333333;padding: 0px 4.5%;}
  .titletd{ width: 35%; font-size:14px; font-weight:650; display:inline-block;vertical-align: top;color:#333333;}
  .infotd{ width: 60%;display: inline-block;color:#333333;}
  .advanceInfo td{ padding-bottom:12px;}
  .greenText{color:#2F7000;}
  .redText{color:#E12D2D;}
  /* 价格详情 */
  .msg-price{width:28%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;}
  .priceText{font-size:18px; font-weight:650;;height: 54px;padding: 0px 4.5%; line-height: 54px;}
  .priceInfo{background-color:rgba(221, 223, 226, 0.2980392156862745); height:auto; font-size:14px;color:#333333;}
  .avgprice{display:block;color:#616161;font-size:12px;}
  .jianye{height: 56px;}
  .mandatory{clear: both;height: 36px;color:#5392F9;}
  .jianye div{margin-bottom: 20px;}
  .jianye span{margin-top:5px;}
  .popverText{ font-size:12px;width:20%;}
  .price-twoline{clear:both; height:50px;padding-top: 10px;}
  .price-oneline{clear:both; height:36px;padding-top: 10px;}
  /* 优惠券信息 */
  .coupon-info{min-height: 22px;font-size:12px; padding: 0 5px; border-radius: 5px;background-color: #d2e6c8;box-sizing: border-box;color: #2f7000;text-align: left;line-height: normal;margin: 0px 4.5%;font-size: 12px;line-height: 22px; display: flex;align-items: center;}
  .coupon-text{color: #2f7000;text-align: left;font-size: 12px;padding: 0 2.5% 0 4.5%;}
  .coupon-img{width:20px; height:20px;line-height: 22px;vertical-align: middle;}
  .coupon-info img{vertical-align: middle;}
  /* 弹框 */
  .frame-text-refresh{height:74px; line-height: 74px;font-size: 16px;color: #4F4C4C;text-align: center;}
  .frame-text-rise{height:74px; line-height: 37px;font-size: 16px;color: #4F4C4C;text-align: center;}
  .dialog-goback{width: 30%; border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;font-weight: 500;font-size: 14px;color: #4F4C4C;}
  .dialog-goon{width: 50%;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
  .dialog-goback:hover,.dialog-goon:hover{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }
  /* 新步骤条 */
  .order-step-new-zh{ display:inline-block; width: 100px;}
  .order-step-new-en{display:inline-block; width: 130px; text-align:center;}
  .step-line-one-zh{width:386px; left: 106px;position:relative; top: 12.5px;}
  .step-line-two-zh{width: 386px;left: 608px;position:relative; top:12.5px;}
  .step-line-one-en{width:342px; left: 136px;position:relative; top: 12.5px;}
  .step-line-two-en{width: 349px;left: 623px;position:relative; top:12.5px;}
  @media screen and (min-width: 1201px) {
    .main{width:1100px;}
  }
  @media only screen and (min-width:1001px) and (max-width:1200px){
  .main {width:95%;}
  .order_button,.order_button:focus{width:30%;height:51px;font-size:16px; font-weight:650; background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
  .order_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}
  }
  @media screen and (max-width: 1000px) {
  .main {width:100%; margin: 0;}
  .stepinfo{text-align: center; margin: 15px auto; width:400px;}
  .stepinfo /deep/ .el-steps{ width:360px !important; margin:0 auto;}
  .order-step{width: 400px;}
  .el-step.is-center .el-step__line{left:30%;}
  .el-step.is-center .step-one-zh{margin-right: 0px;left: 40%;right: -11%;}
  .el-step.is-center .step-one-en{margin-right: 0px;right: -30%;left: 65%;}
  .el-step.is-center .step-two-zh{margin-right: 0px;left: 40%;right: -11%;}
  .el-step.is-center .step-two-en{margin-right: 0px;right: -30%;left: 65%;}
  .mobile-msg-main{ margin: 0px 10px;}
  .step-img{width:25px; height:25px;}
  .step-text{font-size: 12px;}
  .step-text-zh{width:80px;}
  .step-text-en{width:120px;}
  .msg-right-all,.msg-left{clear:both; width:100%;margin:0px;}
  .msg-pink,.msg-green{ font-size: 12px;}
  .pink-tag,.green-tag{width:17%; float:left;}
  .green-text-zh,.green-text-en{height:50px; padding-left:10px; color:#67C23A;}
  .pink-text,.green-text-en{width:80%; height: 35px; line-height: 17.5px; margin: 7.5px 0px;}
  .green-text-zh{width:80%; line-height:50px;}
  .pink-maintext,.green-text-zh,.green-text-en,.pink-text{padding:0px;}
  .pink-text div{display: inline-block;}
  .msginfo-left,.msg-half-one{width:100%;display:block;margin: 0;margin-bottom: 15px;}
  .msginfo-right{width:100%;display:block;margin: 0;}
  .msg-half{width:49%;}
  .tonext{text-align:right;}
  .remind-font{font-size:12px;}
  .order_button,.order_button:focus{width:100%;height:48px;font-size:16px;background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
  .order_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}
  .surplus-room{float:right;}
  .cardremind{right: 0%;top: -90px;width: 51%;height: 126px;}
  .cardremind img{width: 90% !important;}
  .long-margin{margin-bottom:20px;}
  .advanceText, .priceText{font-size: 16px;}
  .tax-margin /deep/ .el-dialog{display: flex;flex-direction: column;margin:0 !important;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}
  .tax-margin /deep/ .el-dialog .el-dialog__body{flex:1; overflow: auto;}
  .tonext{padding: 2px 4.5%;}
  .msg-guest{padding-top:0px;}
  /* 新步骤条 */
  .order-step-new-zh{ display:inline-block; width: 48px;}
  .order-step-new-en{display:inline-block; width: 80px; text-align:center;}
  }
  </style>



// WEBPACK FOOTER //
// src/components/order/WriteChildPay.vue